export default "__VITE_ASSET__DbSSOFWY__"